import React, { useEffect, useRef, useState } from "react";
import data from "../../json/Aboutus/journey.json";
import { ReactComponent as Icon } from "../../Icons/whitearrow.svg";

const Journey = () => {
  let [currentIndex, setCurrentIndex] = useState(0);
  let [translate, setTranslate] = useState(100);
  let [width, setwidth] = useState(window.innerWidth);
  const [startX, setStartX] = useState(null);
  const ref = useRef();

  useEffect(() => {
    const handleResize = () => {
      setwidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  console.log(width);

  const handleprev = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
    // setTranslate(currentIndex * 100);
  };

  const handlenext = () => {
    setCurrentIndex((prev) => (prev < data.data.length - 1 ? prev + 1 : prev));
    // setTranslate(currentIndex * 100);
  };

  const handleTouchStart = (e) => {
    setStartX(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    if (!startX) return;

    const currentX = e.touches[0].clientX;
    const diffX = startX - currentX;

    if (diffX > 50) {
      handlenext();
      setStartX(null);
    } else if (diffX < -50) {
      handleprev();
      setStartX(null);
    }
  };

  let current = data.data[currentIndex];
  return (
    <div className="flex justify-center w-full bg-Darkblue about-journy">
      <div className="2xl:container w-full px-6 py-12 sm:py-16 lg:py-[72px] md:px-10 lg:px-20   flex flex-col items-center justify-center z-10">
        <div className="text-center w-full">
          <h1 className="font-semibold text-24 sm:text-32  md:text-48 text-white">
            {data.Title}
          </h1>
        </div>
        <div className="flex w-full md:w-[80%] relative">
          <div
            ref={ref}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            className="w-full md:w-[80%]  flex flex-col gap-8 lg:gap-12 h-fit mt-12 sm:mt-16"
          >
            <h1 className="text-32 lg:text-48 text-orangeyellow font-semibold">
              {current.yearstart}-{current.yearend}
            </h1>
            <ul className="text-14 md:text-18 text-approachblk flex flex-col gap-4 sm:gap-6">
              {current.achievements.map((it, i) => (
                <li key={i} className="journeylist flex gap-3 text-lightwhite">
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>
          {width > 769 && (
            <div className="flex gap-5 text-white mt-5 journey-arrow">
              <button
                onClick={handleprev}
                className=" flex h-[45px] w-[45px]  rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
                aria-label="Go to previous year"
              >
                <Icon className="text-highlight arrowicon rotate-180" />
              </button>
              <button
                onClick={handlenext}
                className="flex h-[45px] w-[45px] rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
                aria-label="Go to next year"
              >
                <Icon className="text-highlight arrowicon" />
              </button>
            </div>
          )}
        </div>
        <div className=" w-full md:w-[80%] overflow-hidden mt-8 pt-8 lg:mt-12 lg:pt-12 relative border-t-[1px] border-[#202138] ">
          <div
            className={`w-[calc(149px*${data.data.length})] flex gap-4 transistion-transform duration-300 relative]`}
            style={
              currentIndex < 7
                ? { transform: `translateX(-${currentIndex * 152}px)` }
                : { transform: `translateX(-${6 * 152}px)` }
            }
          >
            {data.data.map((item, i) => (
              <button
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`h-10 min-w-[140px] w-[141px] flex justify-center items-center rounded-full text-14 sm:text-18 font-medium border-[1px] border-orangeyellow hover:bg-orangeyellow hover:text-white ${
                  currentIndex === i
                    ? "text-white bg-orangeyellow"
                    : "bg-transparent text-orangeyellow"
                }`}
                aria-label={`Click to view the ${item.yearstart} to ${item.yearend} accomplishments`}
              >
                <h4>
                  {item.yearstart}-{item.yearend}
                </h4>
              </button>
            ))}
          </div>
        </div>

        {width < 769 && (
          <div className="flex gap-3 text-white mt-10">
            <button
              onClick={handleprev}
              className=" flex h-[45px] w-[45px]  rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
              aria-label="Go to previous year"
            >
              <Icon className="text-highlight arrowicon rotate-180" />
            </button>
            <button
              onClick={handlenext}
              className="flex h-[45px] w-[45px] rounded-full border-[1px] border-highlight hover:bg-ctaorange publish-hover flex justify-center items-center"
              aria-label="Go to next year"
            >
              <Icon className="text-highlight arrowicon" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Journey;
